import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { _className, ComponentSync, LL_H_C, LL_V_L, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp, openContent, TS_ButtonLoader } from '@nu-art/thunderstorm-frontend/index';
import { exists, resolveContent } from '@nu-art/ts-common';
import './Header_WithOptionMenu.scss';
import { ICONS } from '../../../../icons/index.js';
export class Header_WithOptionMenu extends ComponentSync {
    shouldComponentUpdate() {
        return true;
    }
    deriveStateFromProps(nextProps, state) {
        return state;
    }
    executeAsyncAction = (event, asyncAction, index, refresh) => {
        if (exists(this.state.actionInProgress))
            return;
        this.setState({ actionInProgress: index }, async () => {
            refresh();
            try {
                await asyncAction(event);
                ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
            }
            catch (err) {
                this.logError(err);
                this.setState({ actionInProgress: undefined }, () => refresh());
            }
        });
    };
    executeSyncAction = (event, action) => {
        if (exists(this.state.actionInProgress))
            return;
        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
        action(event);
    };
    render() {
        const className = _className('quai-manager-ui__header', this.props.className);
        return _jsxs(LL_H_C, { className: className, children: [_jsxs(LL_V_L, { className: 'quai-manager-ui__header__main', children: [this.renderTitle(), this.renderSubtitle()] }), this.renderMenuIcon()] });
    }
    renderTitle = () => {
        const className = _className('quai-manager-ui__header__title', this.props.onTitleClick && 'clickable');
        return _jsxs(LL_H_C, { className: className, onClick: () => {
                if (this.props.onTitleClick) {
                    if (!this.props.asyncTitleClick)
                        this.props.onTitleClick();
                    this.setState({ asyncTitleClickInProgress: true }, async () => {
                        try {
                            await this.props.onTitleClick?.();
                        }
                        catch (err) {
                            this.logError(err);
                            this.setState({ asyncTitleClickInProgress: false });
                        }
                    });
                }
            }, children: [resolveContent(this.props.title), resolveContent(this.props.iconToRender), this.state.asyncTitleClickInProgress && _jsx(TS_ButtonLoader, {})] });
    };
    renderSubtitle = () => {
        if (!this.props.subtitle)
            return;
        return _jsx(LL_H_C, { className: 'quai-manager-ui__header__subtitle', children: resolveContent(this.props.subtitle) });
    };
    renderMenuIcon = () => {
        if (!this.props.menuActions)
            return;
        return _jsx(ICONS.more.component, { className: 'quai-manager-ui__header__actions-icon', ...openContent.popUp.bottom('quai-manager-ui__header__actions', this.renderMenu, 10) });
    };
    renderMenu = (refreshPopup) => {
        return _jsx(_Fragment, { children: this.props.menuActions?.map((action, index) => {
                const actionInProgress = this.state.actionInProgress;
                if (actionInProgress === index)
                    return _jsx("div", { className: 'quai-manager-ui__loader-wrapper', children: _jsx(TS_ButtonLoader, {}) }, action.label);
                const className = _className('quai-manager-ui__header__actions__action', exists(actionInProgress) && 'disabled');
                return _jsx("div", { className: className, onClick: async (event) => {
                        if (!action.isAsync)
                            return this.executeSyncAction(event, action.action);
                        // @ts-ignore
                        this.executeAsyncAction(event, action.action, index, refreshPopup[0]);
                    }, children: action.label }, action.label);
            }) });
    };
}
//# sourceMappingURL=Header_WithOptionMenu.js.map